/**
 * Whether a visitor's contact details give the platform anywhere to actually deliver an invite.
 *
 * 🛑 EMAIL ONLY. The App Server has no SMS send path at all —
 * `helpers/visits/notifications.js#sendVisitInvite` does `if (!v.visitorEmail) return { sent: false,
 * reason: 'visitor has no email address' }` and there is no phone-based branch anywhere in that
 * file. A phone number is still a legitimate thing to collect and store on the visitor, but it must
 * NOT count as an invite channel here: `Redux/visits/saga.js#createVisit` uses this to decide
 * whether to dispatch the `/invite` action at all, and `routesV5/visits/classes.js#invite()`
 * transitions the visit to `invited` (and writes that event) BEFORE it checks whether anything can
 * be sent. Treating a phone number as sufficient would recreate, for phone-only visitors, exactly
 * the "visit marked invited, nothing actually sent" bug this predicate exists to prevent for
 * no-contact visitors (found in code review 2026-09-10 against the first cut, which used
 * `email || phone`).
 *
 * Shared by `NewVisitModal` (decides what the submit button says) and the saga (decides whether to
 * dispatch invite) so the two can never independently drift — they were separately reimplemented in
 * the first cut, which is exactly the kind of thing that silently goes out of sync.
 *
 * 🛑 If SMS invite delivery is ever added server-side, this is the one place to widen.
 *
 * @param {{ email?: string|null, phone?: string|null }} visitor
 * @returns {boolean}
 */
export const hasInviteChannel = (visitor) => !!visitor?.email?.trim?.();
